import EmployeeSalaryLiabilitiesComponents from "../components/EmployeeSalaryLiabilities";
import useEmployeeSalaryLiabilities from "../hooks/useEmployeeSalaryLiabilities";

function EmployeeSalaryLiabilities() {
  const employeeSalaryLiabilitiesProps = useEmployeeSalaryLiabilities();
  return (
    <EmployeeSalaryLiabilitiesComponents {...employeeSalaryLiabilitiesProps} />
  );
}

export default EmployeeSalaryLiabilities;
